module.exports = __webpack_public_path__ + "assets/img/raytrace.1644dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/previews/raytrace.png
// module id = 49
// module chunks = 0